import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

// Images
import me from "./../../assets/images/newLook.jpeg";

// Stylesheets
import "./Home.css";

function Home() {
  const navigate = useNavigate();
  const handleViewWork = () => navigate("/portfolio");
  const handleAboutMe = () => navigate("/about");

  return (
    <Container fluid="true">
      <Stack
        direction={{ xs: "column-reverse", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{
          marginTop: "30px",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 700 }}>
          <main>
            <Typography variant="h6" component="div">
              <p>👋 Hi there, I am Mohamed.</p>
            </Typography>
            <Typography variant="h4" component="div">
              <p style={{ margin: 0, fontWeight: "bold" }}>
                A frontend developer.
              </p>
            </Typography>
            <Typography variant="h5" component="div">
              <p>
                I love to learn &amp; discover all things in web development and
                makes the web an awesome place.
              </p>
            </Typography>
          </main>
          <Button variant="contained" onClick={handleViewWork}>
            View my work
          </Button>
          <Button variant="text" onClick={handleAboutMe}>
            More about me
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-end" },
            width: { xs: "50%", sm: "30%", md: "50%" },
            maxWidth: 700,
          }}
        >
          <figure>
            <img src={me} alt="" style={{ maxWidth: "100%" }} />
          </figure>
        </Box>
      </Stack>
    </Container>
  );
}

export default Home;
